import * as React from "react";
import { EDPageLoader } from "@trailblazer-game/ed-webkit";
import dynamic from "next/dynamic";
import PageLayout from "../components/Shared/PageLayout";

const About = dynamic(() => import("../components/Pages/About/Public/About"), {
  suspense: false,
  ssr: false,
  loading: () => <EDPageLoader in={true}/>,
})
export default function AboutPage() {
  return <PageLayout
    justifyContent={"flex-start"}
    backgroundImage={"/about/about-bg.webp"}>
    <About/>
  </PageLayout>
}

AboutPage.metaData = {
  title: 'Eternal Dragons - Unveiling the Saga Behind the Game',
  description: "Discover the story and vision that brought Eternal Dragons to life. Learn about the creators, their inspiration, and the epic world of dragon warfare."
}